<div class="container">

<mat-selection-list #selectionList >
  @for (role of roles(); track role.name) {
    <mat-list-option [value]="role" [selected]="role.assigned" color="primary">{{role.name}}</mat-list-option>
  }
</mat-selection-list>

  <div class="row">
    <div class="col-4">
      <button type="submit" mat-raised-button color="primary" class="me-2" (click)="onSave()">
        {{ 'SAVE.SAVE' | translate }}
      </button>
      <button type="button" mat-raised-button (click)="onCancel()">
        {{ 'CANCEL' | translate }}
      </button>
    </div>
  </div>
</div>
